<template>
  <TransitionGroup name="fade">
    <slot />
  </TransitionGroup>
</template>
